export default __webpack_public_path__ + "static/media/whiteTcgPowertools.552d69ab.png";